import { render, staticRenderFns } from "./HomeOriginInfoComponent.vue?vue&type=template&id=11637da0&scoped=true&"
import script from "./HomeOriginInfoComponent.vue?vue&type=script&lang=js&"
export * from "./HomeOriginInfoComponent.vue?vue&type=script&lang=js&"
import style0 from "./HomeOriginInfoComponent.vue?vue&type=style&index=0&id=11637da0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11637da0",
  null
  
)

export default component.exports